module.exports = __webpack_public_path__ + "media/images/Network-79ea8d67ad5439cb23b4c01f3d2cce4b.png";